import { render } from "./PaymentFailed.vue?vue&type=template&id=e51e0b66&scoped=true"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"

import "./PaymentFailed.vue?vue&type=style&index=0&id=e51e0b66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e51e0b66"

export default script